module.exports = __webpack_public_path__ + "img/apidays-2021-snapshot-1.988ae854.jpg";